module.exports = __webpack_public_path__ + "img/aaf50f6.png";